import { P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexRow)`
  width: 100%;
  justify-content: space-between;
  gap: 10px;
  border-radius: ${themeStyle.radiusMedium};
  background-color: ${themeStyle.varInkSuperLight};
  padding: 12px;
`;

export const Email = styled(P3)`
  line-height: 17px;
`;
